import local from './etc/local.json';
import qa from './etc/qa.json';
import prod from './etc/prod.json';
import * as _ from "lodash";

export function getProfile() {
    return import.meta.env?.MODE || process.env.REACT_APP_MODE;
}

export function getConfig(profile) {
    profile = profile || getProfile()

    if (profile === "qa") {
        return qa;
    }
    if (profile === "prod") {
        return prod;
    }

    if (profile === "prod:dev") {
        const localProd = _.cloneDeep(prod)
        localProd.poln.redirect_sign_in = local.poln.redirect_sign_in
        localProd.poln.redirect_sign_out = local.poln.redirect_sign_out
        return localProd
    }

    return local;
}

export let cfg = getConfig();
